<div class="description-container">
  <div class="form">
    <div class="description">
      <p class="description-title">{{ titleCondominium }}</p>
      <div class="input-control">
        <app-input
          id="description-input"
          label="Título de exibição no portal"
          maxlength="280"
          messageError="''"
          placeholder=""
          countNumber="280">
        </app-input>
      </div>
      <app-input
        id="description"
        label="Descrição para o portal"
        maxlength="280"
        messageError="''"
        placeholder=""
        countNumber="280">
      </app-input>
    </div>
    <div class="btn-actions">
      <lib-button-tertiary>Cancelar</lib-button-tertiary>
      <lib-button-primary>Salvar</lib-button-primary>
    </div>
  </div>
</div>